import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import styles from 'shared/styles';
import {
  getShowResetResultModal,
} from 'shared/selectors';

export function ResetResultModalImpl({
  open,
  success,
}) {
  if (success) {
    return (
      <Dialog open={open}>
        <DialogTitle>Password Reset Successful</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You have successfully reset your password. Please log in with your new password
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Link style={styles.link} to="/">Log In</Link>
        </DialogActions>
      </Dialog>
    );
  }
  return (
    <Dialog open={open}>
      <DialogTitle>Password Reset Attempt Failed</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Something went wrong with your password reset attempt.
          Please try again with a new forgot password username
          or if the problem persists, contact support@pricepointmoves.com
        </DialogContentText>
      </DialogContent>
      <DialogActions>

        <Link style={styles.link} to="/forgot-password">Forgot Password</Link>
      </DialogActions>
    </Dialog>
  );
}

ResetResultModalImpl.propTypes = {
  open: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
};

export function mapStateToProps(state) {
  const result = getShowResetResultModal(state);
  return {
    open: !!result,
    success: result === 'SUCCESS',
  };
}

export default connect(
  mapStateToProps,
)(ResetResultModalImpl);
